import React, { useState, useEffect } from 'react'
import { Button, Card } from 'react-daisyui'
import { session } from '../../utils/AuthSession'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineShop, AiOutlineShoppingCart, AiOutlineStar, AiOutlineTag } from "react-icons/ai"
import CategoryNav from '../../components/CategoryNav'
import DefaultProduct from "../../assets/default-product.jpg"

function Product() {
    const [category, setCategory] = useState([])
    const [categorySelected, setCategorySelected] = useState()
    const [stores, setStores] = useState([])
    const [store, setStore] = useState([])
    const [store_slug, setStoreSlug] = useState()
    const [productCategory, setProductCategory] = useState([])
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [storeLoading, setStoreLoading] = useState(true)

    const navigate = useNavigate()

    const initStore = async () => {
        setStoreLoading(true)
        const params = {
            access: 'auth',
            method: API.STORE.type,
            url: API.STORE.url,
            reqBody: {
                partner_id: session().partner_id
            }
        }
        const response = await Api(params);
        if (response.status) {
            setStores(response.data)
            if (response.data.length > 0) {
                setStore(response.data[0])
                setStoreSlug(response.data[0].store_slug)
            }
        }
        setStoreLoading(false)
    }

    const InitProduct = async () => {
        if (!store_slug) return

        setLoading(true)
        const params = {
            access: 'auth',
            method: API.PRODUCT.type,
            url: API.PRODUCT.url,
            reqBody: {
                store_slug: store_slug
            }
        }

        const response = await Api(params);
        if (response.status) {
            setCategory(Object.keys(response.data.menu))
            setCategorySelected(Object.keys(response.data.menu) ? Object.keys(response.data.menu)[0] : '')
            setProductCategory(response.data.menu)
        }
        setLoading(false)
    }

    useEffect(() => {
        initStore()
    }, [])

    useEffect(() => {
        InitProduct()
    }, [store_slug])

    useEffect(()=>{
        // setProducts(categorySelected)
        // console.log('categorySelected',categorySelected)
        if(categorySelected) {
            setProducts(productCategory[categorySelected])
        }
    },[categorySelected])

    const handleSelectChange = (e) => {
        setStoreSlug(e.target.value)
        setLoading(true)
    }

    const handleOnClickCategoryNav = (e) => {
        setCategorySelected(e)
        setProducts(productCategory[e])
    }

    const handleProductClick = (e) => {
        navigate(`/product/${e}`)
    }

    // Loading skeleton component
    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-6">
            <div className="bg-gray-200 h-8 rounded w-1/3 mx-auto"></div>
            <div className="bg-gray-200 h-12 rounded"></div>
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
                {[...Array(8)].map((_, i) => (
                    <div key={i} className="bg-gray-200 h-80 rounded-lg"></div>
                ))}
            </div>
        </div>
    )

    const StoreSkeleton = () => (
        <div className="animate-pulse">
            <div className="bg-gray-200 h-12 rounded-lg"></div>
        </div>
    )

    // console.log('product',products)

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <ToastContainer autoClose={1000} />
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Header Section */}
                    <div className="text-center space-y-2">
                        <div className="flex items-center justify-center space-x-2">
                            <AiOutlineShop className="text-2xl text-blue-600" />
                            <h1 className="text-2xl font-bold text-gray-800">Produk</h1>
                        </div>
                        <p className="text-gray-600 text-sm">Pilih produk favorit Anda</p>
                    </div>

                    {/* Store Selector */}
                    {storeLoading ? (
                        <StoreSkeleton />
                    ) : stores.length > 1 ? (
                        <Card className="bg-white shadow-lg border-0">
                            <Card.Body className="p-4">
                                <div className="flex items-center space-x-3">
                                    <AiOutlineShop className="text-blue-600 text-lg" />
                                    <div className="flex-1">
                                        <p className="text-sm font-medium text-gray-600 mb-2">Pilih Toko</p>
                                        <select
                                            className="select select-bordered w-full focus:select-primary"
                                            onChange={handleSelectChange}
                                            value={store_slug}
                                        >
                                            {stores.map((s, i) => (
                                                <option key={i} value={s?.store_slug}>
                                                    {s?.store_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    ) : null}

                    {/* Category Navigation */}
                    {category.length > 0 && (
                        <div className="bg-white rounded-lg shadow-sm p-2">
                            <CategoryNav
                                category={category}
                                defaultCategory={categorySelected}
                                onClick={(e) => handleOnClickCategoryNav(e)}
                            />
                        </div>
                    )}

                    {/* Products Grid */}
                    {loading ? (
                        <LoadingSkeleton />
                    ) : !products || products.length === 0 ? (
                        <Card className="bg-gradient-to-r from-gray-50 to-white border-2 border-dashed border-gray-300">
                            <Card.Body className="text-center py-12">
                                <AiOutlineTag className="text-6xl text-gray-400 mx-auto mb-4" />
                                <p className="text-gray-500 font-medium text-lg">Belum ada produk</p>
                                <p className="text-gray-400 text-sm mt-1">Produk akan segera ditambahkan</p>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="grid grid-cols-2 gap-4">
                            {products.map((p, i) => (
                                <Card
                                    key={i}
                                    className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-0 overflow-hidden cursor-pointer group"
                                    onClick={() => handleProductClick(p.menu_slug)}
                                >
                                    <Card.Body className="p-0">
                                        {/* Product Image */}
                                        <div className="relative h-40 bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center overflow-hidden">
                                            <img
                                                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
                                                src={p.item_image || DefaultProduct}
                                                alt={p.item_name}
                                                onError={(e) => {
                                                    e.target.src = DefaultProduct
                                                }}
                                            />
                                            {/* Price Badge */}
                                            <div className="absolute top-2 right-2 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-bold">
                                                Rp {Intl.NumberFormat('en-ID').format(p.current_price)}
                                            </div>
                                        </div>

                                        {/* Product Info */}
                                        <div className="p-3 space-y-2">
                                            <h3 className="font-semibold text-gray-800 text-sm leading-tight line-clamp-2">
                                                {p.item_name}
                                            </h3>

                                            {/* Price */}
                                            <div className="flex items-center justify-between">
                                                <span className="text-lg font-bold text-green-600">
                                                    Rp {Intl.NumberFormat('en-ID').format(p.current_price)}
                                                </span>
                                                <div className="flex items-center space-x-1">
                                                    <AiOutlineStar className="text-yellow-400 text-sm" />
                                                    <span className="text-xs text-gray-600">4.5</span>
                                                </div>
                                            </div>

                                            {/* Action Button */}
                                            <Button
                                                size="sm"
                                                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white border-none"
                                            >
                                                <AiOutlineShoppingCart className="mr-1" />
                                                Beli Sekarang
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Product